
class exports.CropYear
    constructor: () ->
        # get Crop Year
        @year = moment().add(5, 'months').add(17, 'days').year()
        return @year

    # return current crop year
    get: () ->
        return @year
